import { render, staticRenderFns } from "./contractInfo.vue?vue&type=template&id=6c27b902&scoped=true&"
import script from "./contractInfo.vue?vue&type=script&lang=js&"
export * from "./contractInfo.vue?vue&type=script&lang=js&"
import style0 from "./contractInfo.vue?vue&type=style&index=0&id=6c27b902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c27b902",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c27b902')) {
      api.createRecord('6c27b902', component.options)
    } else {
      api.reload('6c27b902', component.options)
    }
    module.hot.accept("./contractInfo.vue?vue&type=template&id=6c27b902&scoped=true&", function () {
      api.rerender('6c27b902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/contractInfo.vue"
export default component.exports